import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { SensorType } from '../../types/sensor-type';
import { O365SensorView } from '../../base/o365/view/O365SensorView';
import { O365MailFields } from '../../constants';

export class O365MailWebView extends O365SensorView {
  public formGroup: FormGroup;

  static getRequirements(dependencies: any): string {
    return `
        <div class="sensor-requirement" sensor-type="${SensorType.O365_MAIL}">
          <gz-title class="sensor-title">${dependencies.translateFn('For the Mail sensor setup:')}</gz-title>
          <ol>
            <li>${dependencies.translateFn('Your managed application is {registration} in Microsoft Azure AD.', {
              registration:
                '<gz-link type="underline" href="https://docs.microsoft.com/en-us/azure/active-directory/reports-monitoring/howto-configure-prerequisites-for-reporting-api#register-an-application"><span>' +
                dependencies.translateFn('registered') +
                '</span></gz-link>',
            })}</li>
            <li>${dependencies.translateFn(
              'The following Microsoft Graph {boldApplicationPermissions} are configured:',
              {
                boldApplicationPermissions: '<b>' + dependencies.translateFn('Application permissions') + '</b>',
              }
            )}
              <ul style="list-style-type: disc;">
                <li>AuditLog.Read.All</li>
                <li>Mail.Read<br>
                ${dependencies.translateFn(
                  'To delete emails directly from GravityZone, add Mail.ReadWrite instead.'
                )}</li>
                <li>User.Read.All<br>
                ${dependencies.translateFn(
                  'To enforce password reset and disable accounts directly from GravityZone, add User.ReadWrite.All instead.'
                )}</li>
                <li>${dependencies.translateFn(
                  'Optional: IdentityRiskyUser.ReadWriteAll for the ability to mark an Azure AD account as compromised.'
                )}</li>
              </ul>
            </li>
            <li>${dependencies.translateFn(
              'User Administrator role is assigned to your O365 application. It is required only for response actions directly from GravityZone.'
            )}</li>
            <li>${dependencies.translateFn('Admin consent is granted.')}</li>
            <li>${dependencies.translateFn('{clientSecret} is generated unless you have one already.', {
              clientSecret:
                '<gz-link type="underline" href="https://docs.microsoft.com/en-us/azure/active-directory/reports-monitoring/howto-configure-prerequisites-for-reporting-api#get-your-applications-client-secret"><span>' +
                dependencies.translateFn('Client secret ') +
                '</span></gz-link>',
            })}</li>
          </ol>
          <p>${dependencies.translateFn('Note')}</p>
          <p>${dependencies.translateFn('Learn more about {boldMail} sensor requirements {detailLink}.', {
            boldMail: '<b>' + dependencies.translateFn('Mail') + '</b>',
            detailLink:
              '<gz-link type="underline" href="https://docs.microsoft.com/en-us/office/office-365-management-api/get-started-with-office-365-management-apis#register-your-application-in-azure-ad"><span>' +
              dependencies.translateFn('here') +
              '</span></gz-link>',
          })}</p>
        </div>
        `;
  }

  getDomElements(): void {
    super.getDomElements();
    this.dom = {
      $applicationId: this.shadow.querySelector('#' + O365MailFields.APPLICATION),
      $tenantId: this.shadow.querySelector('#' + O365MailFields.TENANT),
      $clientSecret: this.shadow.querySelector('#' + O365MailFields.CLIENT_SECRET),
      ...this.baseDom,
    };
    this.getTranslations();
  }

  setTranslatedStrings() {
    super.setTranslatedStrings();
    this.setBaseTranslatedStrings(SensorType.O365_MAIL);
  }
}
